import moment from 'moment'
import getComponentKey from '@/utils/getComponentKey'

const initialState = {
  selectedInstitutions: [],
  selectedInstitutionGroups: [],
  name: '',
  latinName: '',
  snapshotDate: moment().toDate(),
  dueDate: moment().add(7, 'day').toDate(),
  extendedDueDate: moment().add(14, 'day').toDate(),
  templateSelectors: 5,
  selectedTemplates: [],
  forecasting: false,
  gridKey: getComponentKey(),
  isValid: false,
  data: []
}

const actionTypes = {
  setInstitution: 'setInstitution',
  setInstitutionGroup: 'setInstitutionGroup',
  setName: 'setName',
  setLatinName: 'setLatinName',
  setSnapshotDate: 'setSnapshotDate',
  setDueDate: 'setDueDate',
  setExtendedDueDate: 'setExtendedDueDate',
  setSelectedTemplates: 'setSelectedTemplates',
  setForecasting: 'setForecasting',
  resetForm: 'resetForm',
  changeData: 'changeData'
}

function reducer (state = initialState, action) {
  let newState = null

  switch (action.type) {
    case actionTypes.setInstitution:
      newState = { ...state, selectedInstitutions: action.data }
      break
    case actionTypes.setInstitutionGroup:
      newState = { ...state, selectedInstitutionGroups: action.data }
      break
    case actionTypes.setName:
      newState = { ...state, name: action.data }
      break
    case actionTypes.setLatinName:
      newState = { ...state, latinName: action.data }
      break
    case actionTypes.setSnapshotDate:
      newState = { ...state, snapshotDate: action.data }
      break
    case actionTypes.setDueDate:
      newState = { ...state, dueDate: action.data }
      break
    case actionTypes.setExtendedDueDate:
      newState = { ...state, extendedDueDate: action.data }
      break
    case actionTypes.setSelectedTemplates:
      newState = { ...state, selectedTemplates: action.data }
      break
    case actionTypes.setForecasting:
      newState = { ...state, forecasting: action.data, gridKey: getComponentKey() }
      break
    case actionTypes.resetForm:
      newState = { ...state, name: '', latinName: '' }
      break
    case actionTypes.changeData:
      newState = { ...state, data: action.data }
      break
  }

  if (newState) {
    newState.isValid = checkIsValid(newState)
    return newState
  }

  return state
}

function checkIsValid (state) {
  return ((state.selectedInstitutions !== null && state.selectedInstitutions.length) ||
      (state.selectedInstitutionGroups !== null && state.selectedInstitutionGroups.length)) &&
    (state.name.length > 0) &&
    (state.latinName.length > 0) &&
    (state.snapshotDate !== null) &&
    (state.dueDate !== null) &&
    (state.extendedDueDate !== null) &&
    (state.selectedTemplates.length > 0)
}

export {
  actionTypes,
  initialState,
  reducer
}



// WEBPACK FOOTER //
// ./src/internal-app/components/administration/test-report-group-submission-creator/reducer.js